module.exports = __webpack_public_path__ + "img/detailVM.1e8c3622.png";